import { isRequired } from '../../utils.js';

var internalLink = (_ref => {
  let {
    /**
     * `item_name` is part of the "Item" layer. It is included here to continue the same logic that
     * pre-existed where `target_content_id` defaults to `item_name` if it is not defined. Based on
     * the schema, whenever this data is included in an event, the item layer will also be present so
     * it appears safe to expect `item_name` to be available.
     */
    item_name = isRequired('item_name'),
    target_content_id = item_name,
    target_content_type = isRequired('target_content_type')
  } = _ref;
  return () => ({
    target_content_id: String(target_content_id),
    target_content_type
  });
});

export default internalLink;
